import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

interface MobileNavigationProps {
  isOpen: boolean;
  onClose: () => void;
}

function MobileNavigation({ isOpen, onClose }: MobileNavigationProps) {
  const { isAuthenticated } = useAuth();

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
        onClick={onClose}
      />

      {/* Mobile Menu */}
      <div className="fixed top-0 left-0 right-0 bg-white shadow-lg z-50 md:hidden">
        <div className="px-4 py-4 border-b">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">SG</span>
              </div>
              <span className="ml-2 text-lg font-bold text-gray-900">
                ShopGlobal Pro
              </span>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-gray-600 hover:text-gray-900">
              ✕
            </button>
          </div>
        </div>

        <nav className="px-4 py-2">
          <div className="space-y-1">
            <Link
              to="/how-it-works"
              onClick={onClose}
              className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md font-medium">
              How It Works
            </Link>
            <Link
              to="/pricing"
              onClick={onClose}
              className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md font-medium">
              Pricing
            </Link>

            <div className="border-t border-gray-200 my-2"></div>

            {isAuthenticated ? (
              <>
                <Link
                  to="/dashboard"
                  onClick={onClose}
                  className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md font-medium">
                  Dashboard
                </Link>
                <Link
                  to="/packages"
                  onClick={onClose}
                  className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md font-medium">
                  My Packages
                </Link>
                <Link
                  to="/tracking"
                  onClick={onClose}
                  className="block px-3 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md font-medium">
                  Track Package
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  onClick={onClose}
                  className="block px-3 py-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md font-medium">
                  Login
                </Link>
                <Link
                  to="/signup"
                  onClick={onClose}
                  className="block px-3 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md font-medium text-center">
                  Get Started Free
                </Link>
              </>
            )}
          </div>
        </nav>
      </div>
    </>
  );
}

export default MobileNavigation;
